import { Button, ButtonRow, Heading, Text } from '@ksyos/design-system';
import type { IQuestionnaireFormProps } from '../../../Questionnaire';
import { StyledImg } from '../../../../../elements/atoms/styledImg/StyledImg';
import { CustomContainer } from '../../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../../elements/molecules/stack/Stack';

export function Intro(props: IQuestionnaireFormProps) {
    return (
        <>
            <CustomContainer>
                <Stack>
                    <Heading
                        as="h2"
                        size="xlarge"
                    >
                        ESS vragenlijst
                    </Heading>
                </Stack>

                <Stack>
                    <StyledImg
                        alt="ESS questionnaire intro"
                        src="/assets/images/somnology/questionnaires/ess-questionnaire-intro.svg"
                        srcSet="/assets/images/somnology/questionnaires/ess-questionnaire-intro.svg 1x, /assets/images/somnology/questionnaires/ess-questionnaire-intro.svg 2x, /assets/images/somnology/questionnaires/ess-questionnaire-intro.svg 3x,"
                    />
                </Stack>

                <Stack>
                    <Text>
                        De Epsworth Sleepiness Scale is een zelftest van 8 vragen om je slaperigheid en neiging in slaap
                        te vallen, te bepalen. Het gaat over <b>je huidige leefwijze.</b>
                    </Text>
                </Stack>

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                        width="full-below-small"
                    >
                        Start vragenlijst
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
